<div
  *ngIf="isStudioSourcesList === true"
  class="align-items-center row h-100 to-left-1 {{
    ['LIVE', 'DRAFT', 'TEST'].includes(params.data.status)
  }}"
>
  <button
    mat-button
    [matMenuTriggerFor]="menu"
    (click)="$event.stopPropagation()"
    class="{{ status }} status-bar-studio-status"
    [ngClass]="{ 'disabled' : !isCStudioAdmin || stepsBuilderHelperService.isSourceInfoBeingSaved === true}"
  >
    {{ status }}
  </button>
</div>

<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="studioStatusChange('DRAFT')">
    <span class="DRAFT menu-item">DRAFT</span>
    <mat-icon
      class="menu-icon-style"
      [ngStyle]="status == 'DRAFT' ? { visibility: 'visible' } : ''"
      >done</mat-icon
    >
  </button>
  <button mat-menu-item (click)="studioStatusChange('TEST')">
    <span class="TEST menu-item">TEST</span>
    <mat-icon
      class="menu-icon-style"
      [ngStyle]="status == 'TEST' ? { visibility: 'visible' } : ''"
      >done</mat-icon
    >
  </button>
  <button mat-menu-item (click)="studioStatusChange('LIVE')">
    <span class="LIVE menu-item">LIVE</span>
    <mat-icon
      class="menu-icon-style"
      [ngStyle]="status == 'LIVE' ? { visibility: 'visible' } : ''"
      >done</mat-icon
    >
  </button>
</mat-menu>
